import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser()
    .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .then(function () {
    if ('serviceWorker' in navigator && environment.production) {
        console.log('intentando registrar en main');
        // navigator.serviceWorker.getRegistrations().then(function(registrations) {
        //   for (const registration of registrations) {
        //     if (
        //       registration.active &&
        //       registration.active.scriptURL // &&
        //       // registration.active.scriptURL.indexOf('ngsw-worker.js') > -1
        //     ) {
        //       console.log(
        //         'voy a desregistrar a ' + registration.active.scriptURL
        //       );
        //       registration.unregister();
        //     }
        //   }
        // });
        navigator.serviceWorker.register('sw-master.js');
    }
})
    .catch(function (err) { return console.log(err); });
